import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyPortfolio = lazy(() => import('./Portfolio'));

export const Portfolio: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyPortfolio {...props} />
	</Suspense>
);
